import styled from "styled-components";

export const ModalBody = styled.div`
  text-align: center;
`;

export const Icone = styled.div`
  margin: auto;
  font-size: 40px;

  svg {
    background-color: #fff5eb;
    color: #fe8f14;
    border-radius: 10px;
    padding: 8px;
  }
`;

export const ContainerMensagem = styled.div`
  margin-top: 16px;
`;
